import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowButtonIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 34,
	height: 40,
	viewBox: "0 0 34 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11 19.9941C11 20.1973 11.0391 20.3848 11.1172 20.5566C11.1953 20.7285 11.3125 20.8926 11.4688 21.0488L20.5977 29.9785C20.8555 30.2441 21.1758 30.377 21.5586 30.377C21.8086 30.377 22.0391 30.3145 22.25 30.1895C22.4609 30.0723 22.6289 29.9082 22.7539 29.6973C22.8711 29.4941 22.9297 29.2676 22.9297 29.0176C22.9297 28.6426 22.7891 28.3105 22.5078 28.0215L14.2812 19.9941L22.5078 11.9668C22.7891 11.6777 22.9297 11.3496 22.9297 10.9824C22.9297 10.7246 22.8711 10.4941 22.7539 10.291C22.6289 10.0879 22.4609 9.92773 22.25 9.81055C22.0391 9.68555 21.8086 9.62305 21.5586 9.62305C21.1758 9.62305 20.8555 9.75195 20.5977 10.0098L11.4688 18.9395C11.3125 19.0957 11.1953 19.2598 11.1172 19.4316C11.0391 19.6035 11 19.791 11 19.9941Z",
		fill: "currentColor"
	})
});
export default SvgArrowButtonIcon;
